module.exports = __webpack_public_path__ + "assets/img/plus.0985d6eb.svg";